import React, { ButtonHTMLAttributes, ReactNode } from 'react'

import { styled } from 'styled-components'

type DeleteBtnProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label?: ReactNode
  width?: string
  fontSize?: number
  fontWeight?: number
}

const Btn = styled.button<DeleteBtnProps>`
  display: flex;
  width: ${(props) => (props.width ? `${props.width}` : 'fit-content')};
  height: max-content;
  padding: 10px 20px;
  align-items: center;
  justify-content: center;
  gap: 8px;

  font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : '12px')};
  font-style: normal;
  font-weight: ${(props) => (props.fontWeight ? `${props.fontWeight}` : '400')};
  line-height: ${(props) => (props.fontSize ? `${props.fontSize}px` : '12px')};
  border-radius: 12px;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  appearance: button;
  color: #424242;

  &:hover,
  &.active {
    border-color: #757575;
  }

  &.delete {
    color: #e57373;
    background-color: #ffebee;

    &:hover {
      border-color: #e57373;
    }
  }

  &.light-blue {
    color: #08a8d2;
    background-color: #e9f6fa;

    &:hover {
      border-color: #08a8d2;
    }

    &.active {
      background-color: #08a8d2;
      border-color: #08a8d2;
      color: #ffffff;
    }
  }

  &.dark-grey {
    color: #fdfdfd;
    background-color: #313131;

    svg {
      color: #08a8d2;
      font-size: 20px;
    }

    &:hover {
      border-color: #e0e0e0;
    }

    &:disabled {
      background-color: #7e858e;
    }
  }

  &.inline-menu {
    color: #0a0a18;
    border-radius: 10px;
    gap: 3px;
    justify-content: center;

    svg {
      margin-bottom: -2px;
    }

    &.active,
    &:hover {
      border: 1px solid #08a8d2;
      background: #bdddeb;

      &:hover,
      &:focus {
        border: 1px solid #08a8d2;
        background: #bdddeb;
      }
    }

    &:disabled {
      border: none;
      background: rgb(239, 239, 239);

      &.active,
      &.active:hover,
      &:hover {
        border: none;
        background: rgb(239, 239, 239);
      }

      &.active {
        &.inline-menu,
        &.inline-menu:hover,
        &.profile-item {
          border: 1px solid #08a8d2;
          background: #bdddeb;
        }
      }
    }
  }

  &.underline {
    padding: 10px 12px;
    border-radius: 0;
    background-color: transparent;
    border: none;
    font-size: 13px;

    &:hover,
    &:focus {
      border: none;
      border-bottom: 2px solid #55b5df;
      background: transparent;
    }

    &.active {
      border-bottom: 2px solid #55b5df;
      background-color: transparent;
    }
  }

  &:disabled {
    border: none;

    &:hover {
      border: none;
    }
  }
`

const Button = ({ label, ...props }: DeleteBtnProps) => {
  return (
    <Btn type={props.type ? props.type : 'button'} {...props}>
      {label}
    </Btn>
  )
}

export default Button
